import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  const { t } = useTranslation();
  const location = useLocation();

  return (
    <section className="py-10 md:py-14">
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl md:text-2xl font-heading text-foreground-900">{t('category.title')}</h2>
          <Link to="/category/hot" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap">
            {t('category.viewAll')}
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat, index) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-2 p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-all cursor-pointer animate-scale-in"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100/80 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{cat.name}</span>
              <span className="text-xs text-foreground-400">{cat.videoCount.toLocaleString()}</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}